import { Injectable } from '@angular/core';

@Injectable()
export class ControllerLookupListService
{
    private climateLogicMinAdjust = [];
    private climateLogicMaxAdjust = [];
    private growInDelayList = [];
    private durationForRestrictionStartTime = [];
    private restrictionStartTimes = [];
    private scheduleUpdateList = [];
    private averageWaterDaysList = [];
    private applyToProgramsList = [];

    constructor()
    {
    }

    getClimateLogicMinAdjust()
    {
        if (this.climateLogicMinAdjust.length !== 0)
        {
            return this.climateLogicMinAdjust;
        }
        for (let i = 10; i <= 40; i += 10)
        {
            this.climateLogicMinAdjust.push({ Text: i.toString(), Value: i });
        }
        return this.climateLogicMinAdjust;
    }

    getClimateLogicMaxAdjust()
    {
        if (this.climateLogicMaxAdjust.length !== 0)
        {
            return this.climateLogicMaxAdjust;
        }
        for (let i = 90; i <= 150; i += 10)
        {
            this.climateLogicMaxAdjust.push({ Text: i.toString(), Value: i });
        }
        return this.climateLogicMaxAdjust;
    }

    getClimateLogicGrowInDelay()
    {
        if (this.growInDelayList.length !== 0)
        {
            return this.growInDelayList;
        }
        this.growInDelayList.push({ Text: 'OFF', Value: 0 });
        for (let i = 1; i <= 30; i++)
        {
            this.growInDelayList.push({ Text: i.toString(), Value: i });
        }
        return this.growInDelayList;
    }

    getClimateLogicDurationForRestrictionStartTime()
    {
        if (this.durationForRestrictionStartTime.length !== 0)
        {
            return this.durationForRestrictionStartTime;
        }
        for (let i = 0; i <= 24; i += 0.5)
        {
            this.durationForRestrictionStartTime.push({
                Text: i === 0 ? '---' : i.toFixed(1).toString(),
                Value: (i * 10)
            });
        }
        return this.durationForRestrictionStartTime;
    }

    getClimateLogicRestrictionStartTime()
    {
        if (this.restrictionStartTimes.length !== 0)
        {
            return this.restrictionStartTimes;
        }
        this.restrictionStartTimes.push({ Text: '---', Value: 0 });
        this.restrictionStartTimes.push({ Text: '12:00 AM', Value: 1 });
        for (let i = 2; i <= 24; i++)
        {
            this.restrictionStartTimes.push({ Text: this.getRestrictionTimeString(i), Value: i });
        }
        return this.restrictionStartTimes;
    }

    getScheduleUpdateList()
    {
        if (this.scheduleUpdateList.length !== 0)
        {
            return this.scheduleUpdateList;
        }
        this.scheduleUpdateList.push({ Text: 'Never', Value: 0 });
        this.scheduleUpdateList.push({ Text: '12:00 AM', Value: 1 });
        for (let i = 2; i <= 24; i++)
        {
            this.scheduleUpdateList.push({ Text: this.getRestrictionTimeString(i), Value: i });
        }
        return this.scheduleUpdateList;
    }

    getAverageWaterDays()
    {
        if (this.averageWaterDaysList.length !== 0)
        {
            return this.averageWaterDaysList;
        }
        for (let i = 1; i <= 7; i++)
        {
            this.averageWaterDaysList.push({ Text: i.toString(), Value: i.toString() });
        }
        return this.averageWaterDaysList;
    }

    getApplytoProgramsList()
    {
        if (this.applyToProgramsList.length !== 0)
        {
            return this.applyToProgramsList;
        }
        this.applyToProgramsList.push({ Text: 'None', Value: 3 });
        this.applyToProgramsList.push({ Text: 'A', Value: 0 });
        this.applyToProgramsList.push({ Text: 'A & B', Value: 1 });
        this.applyToProgramsList.push({ Text: 'A & B & C', Value: 2 });
        return this.applyToProgramsList;
    }

    getRestrictionTimeString(index: number)
    {
        const unit = index >= 13 ? 'PM' : 'AM';
        if (index > 13)
        {
            const val = ((index - 1) % 12) > 9 ? ((index - 1) % 12).toString() : '0' + ((index - 1) % 12).toString();
            return val + ':00 ' + unit;
        }
        const value = (index - 1) > 9 ? (index - 1).toString() : '0' + (index - 1).toString();
        return value + ':00 ' + unit;
    }

}
